import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'wd-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.css']
})
export class ListComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
